<div *ngIf="!config?.theme" class="wrapper">
  <div class="heading">
    <div class="title">How it Works</div>
  </div>

  <div class="content">
    <div class="list">
      <div *ngFor="let item of card_points" class="card">
        <div class="image">
          <img loading="lazy" data-src="{{item?.image}}" alt="image" />
        </div>
        <div class="title">{{item?.title}}</div>
        <div class="text">{{item?.text}}</div>
      </div>
      <div class="arrow"><div class="curve"></div></div>
      <div class="arrow flip"><div class="curve"></div></div>
    </div>
  </div>
</div>

<div *ngIf="config?.theme?.match('1')" class="theme-{{config?.theme}}">
  <div class="success">
    <div class="card" *ngFor="let item of infoText">
      <div class="left">
        <div class="title">{{item.title}}</div>
        <div class="text">{{item.text}}</div>
      </div>
      <img data-src="{{item.img}}" loading="lazy" alt="sip">
    </div>
  </div>
</div>